<template>
    <div class="friendly-captcha-div">
      <div ref="captchaContainer"></div>
      <input type="hidden" :name="name" :value="solution" />
      <p>Ce site est protégé par Friendly Captcha. <a href="https://friendlycaptcha.com/privacy/" target="_blank">Politique de confidentialité</a> et <a href="https://friendlycaptcha.com/terms/" target="_blank">Conditions d'utilisation</a> s'appliquent.</p>
    </div>
  </template>
  
  <script>
  
  import { WidgetInstance } from "friendly-challenge";
  
  export default {
    name: 'FriendlyCaptcha',
    props: {
      sitekey: {
        type: String,
        required: true
      },
      name: {
        type: String,
        default: 'captcha'
      }
    },
    data() {
      return {
        widget: null,
        solution: ''
      };
    },
    mounted() {
      this.widget = new WidgetInstance(this.$refs.captchaContainer, {
        sitekey: this.sitekey,
        startMode: 'auto',
        doneCallback: this.onDone
      });
    },
    methods: {
      onDone(solution) {
        this.solution = solution;
        this.$emit('solution-found', solution);
      }
    }
  };
  </script>
  
  <style scoped>
  
  .friendly-captcha-div {
    margin-bottom: 40px;
  }
  </style>
  